// extracted by mini-css-extract-plugin
export default {"suggestionTipPoints":"IdeaDetail_suggestionTipPoints__JfGs2"};